import axios from "axios";
import api from "../api/api";
import router from "@/router";
import AES from '@/assets/js/AES.js'
require("es6-promise").polyfill();
axios.defaults.baseURL = api.requestUrl;
axios.defaults.headers = {
  userLoginId: ""
};
axios.interceptors.request.use(
  config => {
    api.loadingFlag = true;
    config.headers = {
      "Content-Type": "application/json;charset=UTF-8",
      userLoginId: sessionStorage.getItem("userLoginId")
    };
    if(config.url.indexOf("base/file/mgmt/addOneImage")=="-1"){
      config.data = AES.encrypt(config.data);
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);
axios.interceptors.response.use(
  response => {
    api.loadingFlag = false;
    if (response.data.code == "-501") {
      router.push({
        path: "/"
      });
    }
    response.data = JSON.parse(AES.decrypt(response.data));
    return response;
  },
  err => {
    api.loadingFlag = false;
  }
);
export default axios;



// WEBPACK FOOTER //
// ./src/axios/axios.js